import {dashboard_default_data} from '../Constants/C2CDashboardData';
import {getConfigsByKey} from '../Settings/Actions/getConfigsByKey';
import {SaveConfigsDataByKey} from '../Settings/Actions/SaveConfigsDataByKey';

//loadConfigs();
export const loadConfigs = async ({setDashboardData, setIsLoading}) => {
  getConfigsByKey('superadmin').then(config => {
    setDashboardData(
      config?.dashboard_setup?.length > 0
        ? config?.dashboard_setup
        : dashboard_default_data,
    );
  });

  setIsLoading(false);
};
// on CLick Skip
export const onClickSkip = async ({
  item,
  setIsLoading,
  dashboard_data,
  setDashboardData,
}) => {
  setIsLoading(true);

  await SaveConfigsDataByKey({
    config_key_group: 'superadmin',
    config_key_name: 'dashboard_setup',
    value: [
      ...dashboard_data.filter(it => it.id !== item.id),
      {...item, is_skipped: true},
    ],
  });

  loadConfigs({setDashboardData, setIsLoading});
};

// on Mark As Complete
export const onMarkAsComplete = async ({
  item,
  setIsLoading,
  dashboard_data,
  setDashboardData,
}) => {
  setIsLoading(true);

  await SaveConfigsDataByKey({
    config_key_group: 'superadmin',
    config_key_name: 'dashboard_setup',
    value: [
      ...dashboard_data.filter(it => it.id !== item.id),
      {...item, is_completed: true},
    ],
  });

  loadConfigs({setDashboardData, setIsLoading});
};
